export function AntiqueBlueprintSketch() {
  return (
    <svg
      className="absolute bottom-0 right-0 h-[45%] w-auto max-w-[400px] opacity-[0.06] text-amber-900 pointer-events-none z-0"
      viewBox="0 0 100 100"
      fill="none"
      stroke="currentColor"
      strokeWidth="0.2"
      aria-hidden="true"
    >
      {/* Grid */}
      <path d="M 0 10 L 100 10 M 0 30 L 100 30 M 0 50 L 100 50 M 0 70 L 100 70 M 0 90 L 100 90" />
      <path d="M 10 0 L 10 100 M 30 0 L 30 100 M 50 0 L 50 100 M 70 0 L 70 100 M 90 0 L 90 100" />
      {/* Antique amphora silhouette */}
      <path d="M 50 10 C 45 10, 42 12, 42 15 C 42 18, 48 20, 48 25 C 48 27, 40 32, 35 42 C 30 52, 32 68, 40 78 C 45 83, 45 88, 42 90 L 58 90 C 55 88, 55 83, 60 78 C 68 68, 70 52, 65 42 C 60 32, 52 27, 52 25 C 52 20, 58 18, 58 15 C 58 12, 55 10, 50 10 Z" />
      <path d="M 35 42 C 28 42, 26 48, 28 54 C 30 60, 34 62, 36 62" />
      <path d="M 65 42 C 72 42, 74 48, 72 54 C 70 60, 66 62, 64 62" />
      <circle cx="50" cy="15" r="2" />
      <circle cx="50" cy="50" r="12" />
      <circle cx="50" cy="90" r="3" />
    </svg>
  );
}